import PubSub from "underpub-js";
import Equalizer from "../../../../scripts/classes/Equalizer";

var SiteSelector = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-SiteSelector',
	};

	$.extend(true, this.options, options);

};

SiteSelector.prototype.init = function() {

	var self = this;

	// right side text
	this.positionSideText();

	$(window).on('load', function() {
		self.positionSideText();
	});

	PubSub.subscribe("resized", function(){
		self.positionSideText();
	});

	this.options.$el.find(`.${self.options.baseClass}__site`).on({

	    mouseenter: function () {
	        // $(this).find(`.${self.options.baseClass}__videoPlayer`).get(0).play();
	    },

	    mouseleave: function () {
	        // $(this).find(`.${self.options.baseClass}__videoPlayer`).get(0).pause();
	    }

	});

	// set up equalizers to make suer things are aligned even if one slide is missing some elements
	this.textContentEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__textContent`) );
	this.ctaEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__cta`) );

	this.textContentEq.equalizeHeights();
	this.ctaEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.textContentEq.equalizeHeights();
		self.ctaEq.equalizeHeights();
	});

};

SiteSelector.prototype.positionSideText = function() {

	var self = this;

	// left
	var $leftContentWrapper = this.options.$el.find(`.${self.options.baseClass}__site`).eq(0);

	var $leftSideText = $leftContentWrapper.find(`.${self.options.baseClass}__sideText`);
	

	var leftSideTextHeight = $leftSideText.outerWidth(); // element is rotated via css so width is actually height
	var leftSideTextWidth = $leftSideText.outerHeight(); // element is rotated via css so height is actually width

	var leftContentWrapperHeight = $leftContentWrapper.outerHeight();
	var leftContentWrapperWidth = $leftContentWrapper.width();

	// top
	var newTop = (leftContentWrapperHeight / 2) - (leftSideTextHeight / 2);
	$leftSideText.css('top', newTop);

	// left
	// pull left by negative height to align with left edge, then move away by 4% width
	// pulling left by negative height aligns with left edge because we're using transform-origin: 0px 0px
	// which means we pull left by negative height (which is width before our transform), and then
	// we swing the item down 90 degrees by it's top left edge
	var newLeft = leftSideTextWidth + (leftContentWrapperWidth * 0.06); 
	$leftSideText.css('left', newLeft);

	// right
	var $rightContentWrapper = this.options.$el.find(`.${self.options.baseClass}__site`).eq(1);

	var $rightSideText = $rightContentWrapper.find(`.${self.options.baseClass}__sideText`);
	

	var rightSideTextHeight = $rightSideText.outerWidth(); // element is rotated via css so width is actually height
	var rightSideTextWidth = $rightSideText.outerHeight(); // element is rotated via css so height is actually width

	var rightContentWrapperHeight = $rightContentWrapper.outerHeight();
	var rightContentWrapperWidth = $rightContentWrapper.width();

	// top
	var newTop = (rightContentWrapperHeight / 2) - (rightSideTextHeight / 2);
	$rightSideText.css('top', newTop);

	// right
	// pull right by negative height to align with right edge, then move away by 4% width
	// pulling right by negative height aligns with right edge because we're using transform-origin: 0px 0px
	// which means we pull right by negative height (which is width before our transform), and then
	// we swing the item down 90 degrees by it's top right edge
	var newRight = rightSideTextWidth + (rightContentWrapperWidth * 0.06); 
	$rightSideText.css('right', newRight);

};

export default SiteSelector;
